import React from "react";

function BusyOverlay({ message, note }) {
  if (!message) return null;
  return (
    <div className="hm-busy" role="alert" aria-live="assertive" aria-busy="true">
      <div className="hm-busy-card">
        <span className="hm-spinner" aria-hidden="true"></span>
        <p className="hm-busy-msg">{message}</p>
        {note && <p className="hm-busy-note">{note}</p>}
      </div>
    </div>
  );
}

export default BusyOverlay;
